import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './funpsychology.json';

const Funpsychology = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout

            description="Placeholder one-line lesson description for Fun Psychology."
            level="B2"
            title="Fun Psychology"
            image="/Images/fun-psychology.webp"
            seoTitle="Free English Lesson Plans: Fun Psychology"
            seoDescription="Placeholder one-line lesson description for Fun Psychology."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Funpsychology;
